export default {
	name: 'Mariusz Tabak TAB SERVISS',
	address: '34-620 Jodlownik, SLUPIA 100, POLSKO',
	website: 'https://tabserviss.cz',
	isLite: false,
	isNettoBruttoEnabled: true,
	isCommissionFieldVisible: true,
	isCalculateCommissionEnabled: false,
	isMultiCurrencyEnabled: true,
	canNonAdminSeeRouteAsAdmin: false,
	canNonAdminSeeTopButtons: false,
	canChangeStartPoint: true,
	agentsCanEditEverything: true,
	agentsCanSeeRouteTotals: false,
	shouldPDFRouteViewIncludeMap: true,
	shouldDOCRouteViewIncludeMap: true,
	isRouteProductionPdfAvailable: true,
	isRouteProductionDocAvailable: true,
	isStateFieldEnabled: false,
	isInProductionStatusEnabled: true,
	isFilterByCountryEnabled: true,
	canDuplicateOrder: true,
	perPageOptions: [5, 10, 25, 50, 100, 200, 350, 500],
	canSendAsUser: true,
	canSendWithGmail: true,
	canSortByCreatedDate: true,
	isSystemMailerOptionVisible: false,
	canMoveToTrash: true,
	canMoveToComplaints: true,
	canPermanentlyDeleteOrder: false,
	isMultipleOrderAttachmentsEnabled: true,
	isRouteDocumentAttachmentEnabled: true,
	isGroundPreparedEnabled: true,
	isConceptEnabled: true,
	isDistanceFromRoadEnabled: true,
	isGroundPreparationDateEnabled: true,
	isNotesEnabled: true,
	isPaidEnabled: true,
	shouldShowComplaintsInPendingTab: false,
	orderStatusNames: {
		new: 'NOWE',
		pending: 'OCZEKUJĄCE',
		planned: 'PLANOWANE',
		inProduction: 'PRODUKCJA',
		sent: 'WYSŁANE',
		archived: 'ARCHIWUM',
		trashed: 'KOSZ',
		complaint: 'WYCENY',
		all: 'WSZYSTKIE'
	},
	orderPriceLabel: 'Do zapłaty',
	systemEmail: 'powiadomienia@planer.garaze-blaszane.com'
}
